import { Typography } from '@sweep-io/sweep-design';
import { Box } from '@mui/material';
import ConfirmDestructiveDialog from '../../../../common/dialogs/ConfirmDestructiveDialog';

interface ConfirmDeleteFunnelDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmDeleteFunnelDialog = ({
  open,
  onClose,
  onConfirm,
}: ConfirmDeleteFunnelDialogProps) => {
  return (
    <ConfirmDestructiveDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText={'Delete Salesforce Funnel'}
      cancelText={'Cancel'}
      title={'Delete Funnel'}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Typography variant="body">Are you sure you want to delete this funnel?</Typography>
        <Typography variant="body">
          It will be removed from all canvases and cannot be undone.
        </Typography>
      </Box>
    </ConfirmDestructiveDialog>
  );
};
